import styled from 'styled-components';
import { Breakpoints, Colors } from 'styles/Constants';
import DropdownDisable from 'images/icons/dropdown-disable.svg';

export const SectionForm = styled.form`
  margin-left: 150px;
  padding: 0 50px 20px;
  @media (max-width: ${Breakpoints.medium}) {
    margin: 0 0%;
    width: 100%;
  }

  .inputRadio {
    margin-top: 20px;
    display: flex;
    width: 100%;
    margin-top: 15px;
    margin-left: 4%;
    margin-right: 20%;
    div {
      display: flex;
      label {
        margin-top: -8px;
        margin-right: 15px;
        margin-left: 20px;
        font-size: 13px;
      }
    }
    input {
      margin-left: 0%;
      margin-right: 0%;
      @media (max-width: ${Breakpoints.medium}) {
        margin-top: -5px;
      }
    }
  }
`;

export const ButtonStyled = styled.div`
  button {
    text-align: center;
    margin: auto;
    margin-top: 30px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
`;

export const InputWrapper = styled.div`
  display: flex;

  margin: 20px 0;

  @media (max-width: ${Breakpoints.medium}) {
    display: grid;
  }

  label {
    margin-top: 8px;
    padding: 10px;
    width: 10%;
    color: #4d4d4d;
    font-size: 1rem;
    font-weight: 600;
    margin-right: 40px;
    @media (max-width: ${Breakpoints.medium}) {
      padding: 0px;
    }
  }

 .inputRadio {
  display: flex;
  align-items: center;
  gap: 12px;
  }

  .groups-dropdown__control {
  background-color: red;
  color: white;
  border-radius: 8px;
  border: none;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.groups-dropdown__menu {
  background-color: #ff4d4f;
  border-radius: 8px;
  color: white;
}

.groups-dropdown__option {
  background-color: red;
  color: white;
  font-weight: 600;
}

.groups-dropdown__option:hover {
  background-color: #cc0000;
}

}

.inputRadio input {
  appearance: none;
  background: #d8d8d8;
  border-radius: 3em;
  cursor: pointer;
  outline: none;
  border: none;
  height: 10px;
  width: 44px;
  position: relative;
  transition: background 0.3s ease;
}

.inputRadio input:checked {
  background: #7ed321;
}

.inputRadio input::after {
  content: '';
  position: absolute;
  top: 1px;
  left: 1px;
  width: 20px;
  height: 20px;
  background: #fff url('/static/media/check.svg') no-repeat center;
  background-size: 12px;
  border-radius: 50%;
  transition: transform 0.25s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.inputRadio input:checked::after {
  transform: translateX(22px);
  background-color: #92e239;
  background-image: url('/static/media/check.svg');
}


  textarea {
    margin-top: 14px;
    margin-left: 3%;
    transition: all 0.5s ease-out 0s;
    font-family: 'Montserrat', sans-serif;
    background-color: #ffffff;
    border: 1px solid #979797;
    font-size: 0.8125rem;
    color: ${Colors.secondaryNormalGrey};
    border-radius: 10px;
    padding: 10px 15px;
    font-weight: 400;
    width: 360%;
    max-width: 1000px;
    height: 180px;
    outline: none;
    @media (max-width: ${Breakpoints.medium}) {
      margin-left: 2%;
      max-width: 65%;
    }
  }

  .cutText {
    margin-top: 15px;
    margin-bottom: auto;
    width: 180px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .marginUpload select {
    margin-bottom: 10px;
  }

  .checkbox {
    display: flex;
    width: 70%;
    margin-top: 20px;
    margin-right: 20px;
    @media (max-width: ${Breakpoints.medium}) {
      width: 50%;
      margin-top: 0px;
      margin-right: 1px;
    }
  }

  div.dropdown-filter-container {
    margin-top: 15px;
    margin-left: 6%;
    margin-right: 20%;
    @media (max-width: ${Breakpoints.medium}) {
      display: grid;
      width: 100%;
      margin-left: 0%;
    }
  }

  div.dropdown-filter-content__control {
    width: 250px;
    border: 1px solid #979797;
    border-radius: 30px;
    background-color: transparent;
    box-shadow: none;
    height: 30px;

    &:hover,
    &:focus-within {
      border-color: ${Colors.primaryDarkBlue};
      cursor: pointer;
    }
  }

  div.dropdown-filter-content__single-value {
    color: #3e66fe;
    font-weight: 500;
    font-size: 13px;
    text-transform: uppercase;
  }

  div.dropdown-filter-content__value-container {
    margin-left: 2%;
    margin-top: -6px;
  }

  span.dropdown-filter-content__indicator-separator {
    display: none;
  }

  div.dropdown-filter-content__indicator {
    color: rgba(0, 0, 0, 0.54);
  }

  div.dropdown-filter-content__placeholder {
    margin-top: 8px;
    padding-bottom: 15px;
    font-size: 15px;
    color: ${Colors.inactive};
  }

  div.dropdown-filter-content__menu {
    margin-top: 1px;
    width: 170px;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14);
    z-index: 5;
  }

  div.dropdown-filter-content__menu-list {
    padding-top: 0;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  div.dropdown-filter-content__option {
    padding: 6px 8px;
    font-size: 14px;
  }

  div.dropdown-filter-content__option--is-focused {
    background: transparent;
  }

  div.dropdown-filter-content__option:hover,
  div.dropdown-filter-content__option--is-focused:hover,
  div.dropdown-filter-content__option--is-selected {
    background: rgba(0, 0, 0, 0.08);
    font-weight: 500;
    color: #3e66fe;
  }

   .customUpload {
    margin-left: 40%;
    margin-right: 20%;
`;

export const TextCheckbox = styled.p`
  margin-top: 15px;
  color: #4d4d4d;
  font-size: 1rem;
  font-weight: 600;
  @media (max-width: ${Breakpoints.medium}) {
    width: 100%;
  }
`;

export const CalendarSection = styled.div`
  label {
    margin: 0;
    padding: 0;
    width: 100%;
  }
  select {
    width: auto;
    appearance: none;
    -webkit-appearance: none;
    border: 0;
    background: transparent;
    padding: 10px 30px 10px 10px;
    border-radius: 4px;
    outline: 0;
    color: #3e484f;
    background-image: url(/static/media/dropdown-disable.4dd4bae1.svg);
    background-repeat: no-repeat;
    background-position: 90% 50%;
    background-size: 22px;
    cursor: pointer;
    text-align: center;
  }
`;

export const FlexSection = styled.div`
  select {
    appearance: menulist !important;
    -webkit-appearance: menulist !important;
    -moz-appearance: menulist !important;
    background-image: none !important;
    padding-right: 15px !important;
    width: auto !important;
    height: auto !important;
  }
  display: flex;
  align-items: center;
  padding: 0 15px;
  img {
    margin-right: 10px;
    margin-left: 10px;
  }

  svg {
    margin-right: 10px;
    @media (max-width: ${Breakpoints.small}) {
      max-width: 80%;
      margin-right: 10px;
    }
  }

  #spanPoint {
    font-size: 25px;
    margin-left: 8px;
    margin-right: 8px;
    font-weight: 900;
  }

  div.dropdown-filter-content__control {
    width: 100px;
    border: 1px solid #979797;
    border-radius: 10px;
    background-color: transparent;
    box-shadow: none;
    height: 30px;

    &:hover,
    &:focus-within {
      border-color: ${Colors.primaryDarkBlue};
      cursor: pointer;
    }
  }

  div.dropdown-filter-content__single-value {
    color: #3e66fe;
    margin-left: 50%;
    font-weight: 500;
    font-size: 16px;
    text-transform: uppercase;
  }

  div.dropdown-filter-content__value-container {
    padding: 0;
  }

  span.dropdown-filter-content__indicator-separator {
    display: none;
  }

  div.dropdown-filter-content__indicator {
    color: rgba(0, 0, 0, 0.54);
  }

  div.dropdown-filter-content__placeholder {
    padding-bottom: 15px;
    font-size: 15px;
    color: ${Colors.inactive};
  }

  div.dropdown-filter-content__menu {
    margin-top: 1px;
    width: 170px;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14);
    z-index: 5;
  }

  div.dropdown-filter-content__menu-list {
    padding-top: 0;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  div.dropdown-filter-content__option {
    padding: 6px 8px;
    font-size: 14px;
  }

  div.dropdown-filter-content__option--is-focused {
    background: transparent;
  }

  div.dropdown-filter-content__option:hover,
  div.dropdown-filter-content__option--is-focused:hover,
  div.dropdown-filter-content__option--is-selected {
    background: rgba(0, 0, 0, 0.08);
    font-weight: 500;
    color: #3e66fe;
  }
`;

export const GridComponent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const MarginButton = styled.div`
  padding-left: 150px;
  display: flex;
  button {
    text-align: center;
    margin: auto;
    display: flex;
    @media (max-width: ${Breakpoints.small}) {
      margin-top: 20px;
    }
  }
`;

export const NetworkFlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items; center;
    input{
      margin: 0 20px;
    }
      @media (max-width: ${Breakpoints.xxLarge}) {
      max-width: 85%;
    }
`;

export const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: 9fr 3fr;
  padding: 0 200px;
`;
export const InputsWrapper = styled.div``;

export const LabelForm = styled.div`
  grid-template-columns: 190px 1fr;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  display: grid;
  width: 100%;
  input {
    transition: all 0.5s ease-out 0s;
    font-family: 'Montserrat', sans-serif;
    background-color: #ffffff;
    border: 1px solid #979797;
    font-size: 0.8125rem;
    color: ${Colors.secondaryNormalGrey};
    border-radius: 10px;
    padding: 10px 15px;
    font-weight: 400;
    display: block;
    width: 100%;
    outline: none;
    @media (max-width: ${Breakpoints.large}) {
      max-width: 80%;
    }
    @media (max-width: ${Breakpoints.xxLarge}) {
      max-width: 85%;
    }
  }

  &:not(.calendar-container) select {
    -moz-appearance: none;
    -webkit-appearance: none;
    background-image: url(/static/media/dropdown-disable.4dd4bae1.svg);
    -webkit-transition: all 0.1s ease-out 0s;
    transition: all 0.1s ease-out 0s;
    background-repeat: no-repeat;
    background-position: 90% 50%;
    background-size: 22px;
    padding-right: 50px;
    height: 40px;
    width: 300px;
    -webkit-transition: all 0.5s ease-out 0s;
    transition: all 0.5s ease-out 0s;
    font-family: 'Montserrat', sans-serif;
    background-color: #ffffff;
    border: 1px solid #979797;
    font-size: 0.8125rem;
    color: #4d4d4d;
    border-radius: 10px;
    padding: 10px 15px;
    font-weight: 400;
    display: block;
    outline: none;
    margin-bottom: 10px;
  }

  select.group-select {
    -moz-appearance: none;
    -webkit-appearance: none;
    background-image: url(/static/media/dropdown-disable.4dd4bae1.svg);
    -webkit-transition: all 0.1s ease-out 0s;
    transition: all 0.1s ease-out 0s;
    background-repeat: no-repeat;
    background-position: 90% 50%;
    background-size: 22px;
    padding-right: 50px;
    height: 40px;
    width: 300px;
    -webkit-transition: all 0.5s ease-out 0s;
    transition: all 0.5s ease-out 0s;
    font-family: 'Montserrat', sans-serif;
    background-color: #ffffff;
    border: 1px solid #979797;
    font-size: 0.8125rem;
    color: #4d4d4d;
    border-radius: 10px;
    padding: 10px 15px;
    font-weight: 400;
    display: block;
    outline: none;
    margin-bottom: 10px;
  }

  select {
    -moz-appearance: none;
    -webkit-appearance: none;
    background-image: url(/static/media/dropdown-disable.4dd4bae1.svg);
    -webkit-transition: all 0.1s ease-out 0s;
    transition: all 0.1s ease-out 0s;
    background-repeat: no-repeat;
    background-position: 90% 50%;
    background-size: 22px;
    padding-right: 50px;
    height: 40px;
    width: 300px;
    -webkit-transition: all 0.5s ease-out 0s;
    transition: all 0.5s ease-out 0s;
    font-family: 'Montserrat', sans-serif;
    background-color: #ffffff;
    border: 1px solid #979797;
    font-size: 0.8125rem;
    color: #4d4d4d;
    border-radius: 10px;
    padding: 10px 15px;
    font-weight: 400;
    display: block;
    outline: none;
    margin-bottom: 10px;
  }

  input.input-search {
    background-image: url(${DropdownDisable});
    transition: all 0.1s ease-out 0s;
    background-repeat: no-repeat;
    background-position: 95% 55%;
    background-size: 22px;
    padding-right: 50px;
    outline: none;
    height: 40px;
    width: 400px;
  }

  div.search-containe {
    position: absolute;
    background-color: #ffffff;
    z-index: 1;
    box-shadow: 0 1px 12px 0 rgb(0 0 0 / 20%);
    margin: 10px 0 0 10px;
    width: 450px;
    input {
      position: relative;
      user-select: none;
      cursor: pointer;
      display: block;
      outline: none;
      height: 15px;
      width: 15px;
      padding: 7px;
      margin-right: 20px;
    }
  }

  div input.input-search.selected {
    border: 1px solid #004fea;
    color: #004fea;
  }

  input.input-search.selected::placeholder {
    color: #004fea;
    font-size: 13px;
    font-weight: 500;
  }

  div.search-containe .search-result .checkbok-wrapper:hover {
    background-color: #cecece;
  }

  div.search-containe .search-result .checkbok-wrapper .icon-Group {
    fill: #757575;
    width: 20px;
    height: 20px;
    margin-right: 20px;
  }

  div.search-containe .search-result .checkbok-wrapper label {
    color: #333333;
    width: 450px;
    margin-top: 1px;
    margin-bottom: 11px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-size: 13px;
    cursor: pointer;
    text-transform: capitalize;
  }

  div.search-containe
    .search-result
    .checkbok-wrapper
    input[type='checkbox']:checked
    ~ label {
    color: #004fea;
    text-transform: capitalize;
  }

  div.search-result {
    overflow: auto;
    height: 250px;
    border: none;
    padding: 0px;
    width: 100%;
  }

  div.checkbok-wrapper {
    justify-content: flex-start;
    border-bottom: 1px solid rgba(216, 216, 216, 0.3);
    cursor: pointer;
    margin: 2px 2px;
    padding: 10px;
    display: flex;
  }

  div.network {
    display: flex;
    padding: 20px 0;

    @media (max-width: ${Breakpoints.small}) {
      display: -webkit-box;
    }

    input {
      appearance: none;
      background: #d8d8d8;
      border-radius: 3em;
      cursor: pointer;
      outline: none;
      border: none;
      height: 10px;
      width: 44px;
      position: relative;
      transition: background 0.3s ease;
    }
    input:checked {
      background: #7ed321;
    }
    input:after {
      content: '';
      position: absolute;
      top: 1px;
      left: 1px;
      width: 20px;
      height: 20px;
      background: #fff url('/static/media/check.svg') no-repeat center;
      background-size: 12px;
      border-radius: 50%;
      transition: transform 0.25s ease;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    }
    input:checked:after {
      transform: translateX(22px);
      background-color: #92e239;
      background-image: url('/static/media/check.svg');
    }
  }

  textarea {
    transition: all 0.5s ease-out 0s;
    font-family: 'Montserrat', sans-serif;
    background-color: #ffffff;
    border: 1px solid #979797;
    font-size: 0.8125rem;
    color: ${Colors.secondaryNormalGrey};
    border-radius: 10px;
    padding: 10px 15px;
    font-weight: 400;
    display: block;
    width: 100%;
    outline: none;
    @media (max-width: ${Breakpoints.large}) {
      max-width: 80%;
    }
    @media (max-width: ${Breakpoints.xxLarge}) {
      max-width: 85%;
    }
  }

  label {
    color: ${Colors.secondaryNormalGrey};
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
  }

  p {
    font-size: 12px;
    line-height: 1.42857;
    color: #333333;
    margin-right: 10px;
  }

  .marginText {
    margin-top: -120%;
  }

  .marginColumn {
    margin-top: 2%;
    margin-bottom: 5%;
  }

  .marginLabel {
    margin-block-end: auto;
  }

  .column-2 {
    display: flex;

    label {
      margin-right: 70px;
      margin-top: 10px;
    }

    input {
      width: 7%;
      text-align: center;
    }
  }

  .borde {
    margin-top: 40px;
    border-bottom: 1px solid #979797;
  }

  .positionIcon {
    position: relative;
    left: 20px;
    bottom: 30px;
    margin-right: 12px;
  }

  .marginFile {
    margin-top: 0px;
    position: absolute;
    margin-left: 53%;

    @media (min-width: ${Breakpoints.cLarge}) and (max-width: ${Breakpoints.cxLarge}) {
      margin-left: 80%;
      margin-top: 25%;
    }
  }
`;

export const CalendarContainer = styled.div`
  select {
    appearance: menulist !important;
    -webkit-appearance: menulist !important;
    -moz-appearance: menulist !important;
    background-image: none !important;
    padding-right: 15px !important;
    width: auto !important;
    height: auto !important;
  }
`;
